import React from 'react';
import ModalNovoTituloParcelado from './ModalNovoTituloParcelado';

// Lançamento manual de Contas a Pagar (F4) — título avulso, agora com
// parcelamento (regras de vencimento no ModalNovoTituloParcelado).
export default function ModalNovaContaPagar({ fornecedores, contasFinanc, planoContas, onSalvo, onClose }) {
  return (
    <ModalNovoTituloParcelado
      tipo="pagar"
      entidades={fornecedores}
      contasFinanc={contasFinanc}
      planoContas={planoContas}
      onSalvo={onSalvo}
      onClose={onClose}
    />
  );
}
